import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { FaqList } from '../interfaces/faq/faq-list';

@Injectable({
  providedIn: 'root'
})
export class FaqDataService extends BaseCrudService<FaqList, FaqList>{

  private i18nServiceUrl: string = 'i18n/';

  constructor() {
    super();
  }

  /**
   * get FAQ-List
   * TODO should be in database and managed with admin-portal
   * @param languageKey
   */
  getFaqData(languageKey: string): Observable<any> {
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<FaqList>(this.i18nServiceUrl + 'faq/' + languageKey + '.json', {headers});
  }

}
